import {Container, Singleton} from 'typescript-ioc'
import BaseApi from '@/api/BaseApi'
import Paging, {BasePqForm} from "biz-ts/src/api/Paging";
import Product from "@/model/Product";
import {PcreateForm, PeditForm} from "@/form/ProductForm";
import {NetConfigMode} from "@/module/device/NetConfigMode";
import _ from 'lodash';

@Singleton
export default abstract class ProductApi {
    abstract query(id: number): Promise<Product>

    abstract paging(form: PpagingForm): Promise<Paging<Product>>

    abstract list(): Promise<Array<Product>>

    abstract create(form: PcreateForm): Promise<Product>

    abstract edit(form: PeditForm): Promise<Product>

    abstract delete(id: number): Promise<void>
}

class ProductApiImpl extends BaseApi implements ProductApi {

    protected urlPrefix = 'product'

    query(id: number): Promise<Product> {
        return this.axios.post('query', {id: id})
    }

    paging(form: PpagingForm): Promise<Paging<Product>> {
        const f = _.cloneDeep(form)
        if (_.isEmpty(f.netConfigMode))
            f.netConfigMode = undefined
        return this.axios.post('paging', f)
    }

    list(): Promise<Array<Product>> {
        return this.axios.post('list')
    }

    create(form: PcreateForm): Promise<Product> {
        return this.axios.post('create', form)
    }

    edit(form: PeditForm): Promise<Product> {
        return this.axios.post('edit', form)
    }

    delete(id: number): Promise<void> {
        return this.axios.post('delete', {id: id})
    }
}

Container.bind(ProductApi).to(ProductApiImpl)

export class PpagingForm extends BasePqForm {
    id?: number = undefined
    name?: string = undefined
    key?: string = undefined
    natureKey?: string  = undefined
    netConfigMode?: NetConfigMode = undefined

    companyIds: Array<number> = []
    categoryIds: Array<number> = []
}
